import LegalLayout from "./LegalLayout";

const sections = [
  {
    heading: "Nature of Potential Harm",
    blocks: [
      { type: "p", text: "The user expressly acknowledges that the Delta GreenX platform contains confidential business systems, proprietary commercial methodologies, trade-secret operational frameworks, strategic investor materials, artificial intelligence systems, computational intelligence models, platform architecture, market intelligence systems, business process methodologies, interface systems, and other proprietary assets." },
      { type: "p", text: "Unauthorized disclosure, misuse, reproduction, extraction, recording, replication, benchmarking, dissemination, reverse engineering, derivative development, or commercial exploitation of any such asset may cause immediate, substantial, irreparable, and difficult-to-quantify harm to:" },
      { type: "ul", items: [
        "Delta GreenX business operations",
        "Strategic relationships",
        "Market positioning",
        "Investor confidence",
        "Commercial reputation",
        "Competitive advantage",
        "Future enterprise value",
      ]},
    ],
  },
  {
    heading: "Inadequacy of Monetary Damages",
    blocks: [
      { type: "p", text: "The user agrees that any actual, suspected, attempted, indirect, preparatory, or threatened breach of confidentiality obligations, intellectual property rights, trade secret protections, anti-recording restrictions, investor access limitations, platform usage obligations, computational intelligence protections, or other legal rights of Delta GreenX may result in harm that cannot be adequately compensated solely through monetary damages." },
      { type: "p", text: "Accordingly, Delta GreenX shall be entitled, at its sole discretion and without prior notice, to immediately initiate:" },
      { type: "ul", items: [
        "Protective legal action and emergency enforcement procedures",
        "Preservation measures and internal investigations",
        "Forensic reviews and access restrictions",
        "Digital evidence preservation protocols",
        "Commercial enforcement actions",
        "Reputational protection actions",
        "All other lawful protective measures deemed necessary",
      ]},
    ],
  },
  {
    heading: "Trigger Events",
    blocks: [
      { type: "p", text: "The user agrees that in the event Delta GreenX reasonably determines, suspects, or detects any of the following, Delta GreenX may exercise the rights and remedies described in this Agreement:" },
      { type: "ul", items: [
        "Unauthorized recording, screen capture, or photography",
        "Platform replication or competitive intelligence gathering",
        "Investor misconduct or trade secret extraction",
        "Algorithmic benchmarking",
        "Confidential information leakage or unauthorized internal circulation",
        "Strategic misuse or platform cloning",
        "Commercial imitation or unauthorized derivative development",
        "Unfair competition, business interference, or reputational harm",
      ]},
    ],
  },
  {
    heading: "Available Remedies",
    blocks: [
      { type: "p", text: "Delta GreenX shall have the unrestricted right to:" },
      { type: "ul", items: [
        "Immediately suspend or terminate platform access",
        "Revoke investor participation privileges",
        "Invalidate strategic discussions",
        "Restrict future communications",
        "Preserve all relevant technical evidence",
        "Initiate digital forensic investigations",
        "Engage cybersecurity experts and outside counsel",
        "Notify relevant strategic stakeholders where necessary",
        "Pursue all available legal, commercial, contractual, equitable, and statutory remedies",
      ]},
      { type: "p", text: "Delta GreenX may further seek:" },
      { type: "ul", items: [
        "Temporary restraining orders and preliminary injunctions",
        "Permanent injunctions and emergency equitable relief",
        "Intellectual property and trade secret enforcement orders",
        "Confidentiality enforcement actions",
        "Reputational protection remedies",
        "Unfair competition and business interference claims",
        "Cyber misuse and commercial damages claims",
      ]},
    ],
  },
  {
    heading: "Damages Recovery",
    blocks: [
      { type: "p", text: "Delta GreenX reserves the right to pursue recovery of all losses, damages, and expenses, including:" },
      { type: "ul", items: [
        "Enforcement, investigative, and legal fees",
        "Forensic expenses and technology protection costs",
        "Strategic disruption and investor opportunity losses",
        "Reputational and brand harm damages",
        "Market displacement and competitive-advantage dilution damages",
        "Direct, indirect, consequential, incidental, statutory, punitive, or equitable damages permitted by law",
      ]},
    ],
  },
  {
    heading: "Dispute Resolution & Arbitration",
    blocks: [
      { type: "p", text: "Any dispute, controversy, claim, allegation, or legal proceeding arising out of or relating to platform access, demonstrations, observation of workflows, investor evaluation activities, onboarding activities, alleged misuse of confidential information, or any matter relating to platform use shall be resolved exclusively through confidential and binding arbitration under applicable arbitration laws and procedures." },
      { type: "p", text: "The user expressly and irrevocably waives any right to:" },
      { type: "ul", items: [
        "Public litigation",
        "Class action participation or representative claims",
        "Collective proceedings",
        "Jury trials",
        "Public hearings or public disclosure of proceedings",
        "Any other form of public dispute resolution",
      ]},
      { type: "note", text: "Exception: Delta GreenX may seek emergency judicial intervention where necessary to prevent immediate harm, preserve trade secrets, protect investor relationships, prevent competitive misuse, or secure emergency injunctive relief." },
    ],
  },
  {
    heading: "Survival & Electronic Acceptance",
    blocks: [
      { type: "p", text: "All obligations, waivers, liabilities, restrictions, enforcement rights, confidentiality obligations, intellectual property and trade secret protections, dispute resolution obligations, and remedies contained within this Agreement shall survive indefinitely and shall remain fully enforceable regardless of whether the user's account is terminated, access is revoked, investor discussions cease, strategic relationships end, commercial negotiations fail, contractual relationships expire, or platform usage otherwise concludes." },
      { type: "p", text: 'By clicking "ENTER PLATFORM," accessing any portion of Delta GreenX, participating in any demonstration, or otherwise interacting with platform assets, the user expressly acknowledges electronic acceptance of these terms and agrees that such acceptance shall constitute a legally binding electronic signature enforceable under all applicable electronic commerce, digital transaction, arbitration, confidentiality, intellectual property, trade secret, and commercial enforcement laws.' },
    ],
  },
];

export default function RiskDisclaimer() {
  return (
    <LegalLayout
      title="Dispute Resolution, Enforcement & Remedies"
      eyebrow="Legal · Enforcement"
      effective="May 1, 2026"
      lastUpdated="May 1, 2026"
      intro={[
        "This document defines Delta GreenX's enforcement rights, available remedies, damages recovery, and the binding arbitration framework that governs all disputes arising out of platform access or use.",
      ]}
      sections={sections}
      contact="legal@deltagreenx.com"
    />
  );
}
